import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Batches from './pages/Batches';
import Attendance from './pages/Attendance';
import MarkAttendance from './pages/MarkAttendance';
import Payments from './pages/Payments';
import Reports from './pages/Reports';
import UserManagement from './pages/UserManagement';
import Services from './pages/Services';
import PublicForm from './pages/PublicForm';
import StudentsSheet from './pages/StudentsSheet';
import Submissions from './pages/Submissions';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('token'));
  const [userRole, setUserRole] = useState(() => localStorage.getItem('role') || 'admin');

  useEffect(() => {
    if (isAuthenticated) {
      setUserRole(localStorage.getItem('role') || 'admin');
    }
  }, [isAuthenticated]);

  const ProtectedRoute = ({ children, allowedRoles = ['admin'] }) => {
    if (!isAuthenticated) return <Navigate to="/login" />;
    if (!allowedRoles.includes(userRole)) return <Navigate to="/mark-attendance" />;
    return children;
  };

  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register" element={<PublicForm />} />
          <Route path="/" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee', 'attendance_only']}><Dashboard /></ProtectedRoute>} />
          <Route path="/students" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee']}><Students /></ProtectedRoute>} />
          <Route path="/students-sheet" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee']}><StudentsSheet /></ProtectedRoute>} />
          <Route path="/submissions" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee']}><Submissions /></ProtectedRoute>} />
          <Route path="/batches" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee']}><Batches /></ProtectedRoute>} />
          <Route path="/attendance" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee']}><Attendance /></ProtectedRoute>} />
          <Route path="/mark-attendance" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee', 'attendance_only', 'face_only']}><MarkAttendance /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute allowedRoles={['admin', 'admin_nofee']}><Payments /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute allowedRoles={['admin']}><Reports /></ProtectedRoute>} />
          <Route path="/services" element={<ProtectedRoute allowedRoles={['admin']}><Services /></ProtectedRoute>} />
          <Route path="/user-management" element={<ProtectedRoute allowedRoles={['admin']}><UserManagement /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
